<!-- 注册/登录 -->
<template>
  <div
    class="registrationLogin loginCom"
    ref="registrationLogin"
  >
    <div class="codeLogin loginMmain">
      <div class="codeLoginTop">
        <div class="codeLoginTitle">注册/登录</div>
        <div class="codeLoginDescribe fontWeightCom">新用户注册将自动创建账号</div>
      </div>
      <div class="codeLoginMain">
        <input
          type="tel"
          placeholder="请输入手机号"
          maxlength="11"
          class="codeLoginPhone fontWeightCom mobile"
          @input="getPhoneIpt"
          v-model="userPhone"
          ref="registrIpt"
          @keyup.delete="onDelete()"
        />
      </div>
      <div class="codeLoginLine loginLine"></div>
    </div>
    <sendButton
      :buttonText="validationBtn"
      @sendCodeBtn="validationCode"
      loginWay="registrationLogin"
      :isActiveClass="isActiveClass"
    />
    <div
      class="passLoginBtn fontWeightCom"
      @click="passLoginBtn"
    >密码登录</div>
    <div class="Bottom registrBottom">
      <termsAgreement @showAgreement="showAgreement" @receivePraive="receivePraive" />
    </div>
    <div
      class="sliderCode"
      v-show="sliderVer"
    >
      <div
        id="MyDomId"
        class="nc-container"
      ></div>
    </div>
    <div class="van-popup-agreement">
      <van-popup
        v-model="agreementVisible"
        closeable
        :overlay="false"
        close-icon-position="top-right"
        position="bottom"
        @closed="closeAgreement"
        close-icon="https://iqh-zt-pord-cdn.iqihang.com/ark-question-bank/closeIcon.png"
        :style="{width:'100%',height:'400px',zIndex:10003}"
      >
        <SeverAgreement v-if="agreementType === 1"/>
        <PrivacyAgreement v-else/>
      </van-popup>
    </div>
  </div>
</template>

<script>
import '@/assets/css/loginCommon.css';
import { Toast } from 'vant';
import sendButton from './sendButton.vue';
import termsAgreement from './termsAgreement.vue';
import SeverAgreement from './severAgreement.vue'
import PrivacyAgreement from './praviteAgreement'
import { reqPhonesliderCode } from '@/api/login';

export default {
  namespaced: true,
  components: {
    sendButton,
    termsAgreement,
    SeverAgreement,
    PrivacyAgreement
  },
  data() {
    return {
      userPhone: '',
      isActiveClass: false,
      urlParams: null,
      pagesParams: null,
      fromPath: '',
      validationBtn: '发送验证码',
      loading: false,
      pravieStatus: false,
      sliderVer: false, // 是否显示滑块验证（显示/隐藏）
      tagNcFlag: false, // 滑块是否存在
      obj: {},
      agreementVisible: false, // 协议开关
      agreementType: 1, // 1服务协议，2隐私协议
    };
  },
  computed: {},
  watch: {
    userPhone() {
      this.changePhone();
    },
  },
  methods: {
    showAgreement(type){
      this.agreementType = (type === 'serve') ? 1 : 2
      this.agreementVisible = true
    },
    closeAgreement(){
      this.agreementVisible = false
    },
    useNvc() {
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      // 实例化nvc 对无痕验证进行初始化操作
      // eslint-disable-next-line no-undef
      AWSC.use('nvc', (state, module) => {
        // 初始化 调用module.init进行初始化
        window.nvc = module.init({

          // 应用类型标识。它和使用场景标识（scene字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
          appkey: 'FFFF0N0000000000ACF9',
          // 使用场景标识。它和应用类型标识（appkey字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
          scene: 'nvc_message_h5',
          // test: module.TEST_BLOCK,
          // test: module.TEST_NC_PASS,
          // test: module.TEST_NC_BLOCK,
          // // 二次验证(滑块验证成功)获取人机信息串，跟随业务请求一起上传至业务服务器，由业务服务器进行验签。
          success(data) {
            // 滑块验证成功
            _this.getNewVerification(data);
          },
          // 前端二次验证失败时触发该回调参数
          fail(failCode) {
            Toast('验证失败，请刷新页面重新尝试');
          },
          // 前端二次验证加载异常时触发该回调参数。
          error(errorCode) {
            console.log(errorCode);
          },
        });
      });
    },
    receivePraive(status) {
      this.pravieStatus = status;
    },
    changePhone() {
      const { userPhone } = this;
      if (String(userPhone).length === 11) {
        this.isActiveClass = true;
        return;
      }
      this.isActiveClass = false;
    },
    onDelete() {
      const { userPhone } = this.$store.state;
      if (userPhone?.length === 0) return;
      this.$store.dispatch('saveUserPhone', '');
    },
    getPhoneIpt() {
      const { userPhone } = this;
      if (userPhone.length >= 11) {
        this.userPhone = userPhone.slice(0, 11);
        this.$store.dispatch('saveUserPhone', userPhone);
      }
    },
    passLoginBtn() {
      this.$emit('changeType','password')
    },
    async validationCode() {
      if (this.loading) {
        return;
      }
      if (this.sliderVer) return;
      const { userPhone } = this;
      const isPhone = /^1[3-9]\d{9}$/g.test(userPhone);
      if (String(userPhone).length === 11 && isPhone && this.isActiveClass) {
        this.obj = Object.assign(this.pagesParams ? JSON.parse(this.pagesParams) : {}, {
          loginWay: 'login',
        });
        if (!this.pravieStatus) {
          Toast('请阅读并勾选隐私协议');
          return;
        }
        this.loading = true;
        const _this = this;
        window.nvc.getNVCValAsync((nvcVal) => {
          _this.getNewVerification(nvcVal);
        });
        // this.validationBtn = '正在发送验证码';
        // const result = await queryCode({
        //   type: this.loginWay ? this.loginWay : 'login',
        //   phone: String(userPhone) || '',
        // });
        // this.loading = false;
        // this.validationBtn = '发送验证码';
        // if (result.code === 0) {
        //   this.$router.replace({
        //     name: 'getCode',
        //     query: JSON.parse(this.urlParams),
        //     params: obj,
        //   });
        // } else {
        //   Toast(result.msg);
        // }
      } else {
        Toast('请输入正确格式的手机号');
      }
    },
    // 发送验证码
    async getNewVerification(nvcVal) {
      this.validationBtn = '正在发送验证码';
      const data = {
        company: 0,
        type: this.loginWay ? this.loginWay : 'login',
        phone: String(this.userPhone) || '',
        nvcVal,
      };
      const res = await reqPhonesliderCode(data);
      this.loading = false;
      if (res.code === 0) {
        this.validationBtn = '发送验证码';
        if (res.data.status === 0) {
          this.$emit('changeType','code')
        } else if (res.data.status === 1) {
          // 业务服务器请求回调控制是否需要二次验证
          if (res.data.bizCode === 800 || res.data.bizCode === 900) {
            // 无痕验证失败，直接拦截
            Toast('验证失败，请重新尝试');
          } else if (res.data.bizCode === 400) {
            // console.log(this.tagNcFlag, 'this.tagNcFlag');
            this.sliderVer = true;
            if (!this.tagNcFlag) {
              // // 无痕验证失败，需要触发二次滑块验证
              const ncoption = {
                // 二次验证文案配置
                renderTo: '#MyDomId',
                upLang: {
                  cn: {
                    // 加载状态提示。
                    LOADING: '加载中...',
                    // 等待滑动状态提示。
                    SLIDE: '请按住滑块，拖动到最右边',
                    // 验证通过状态提示。
                    SUCCESS: "<a style='margin-left:30px;-webkit-text-fill-color: #fff;'>验证通过</a>",
                    // 验证失败触发拦截状态提示。
                    ERROR: '滑动失败，请重新滑动,点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
                    // 验证失败触发拦截状态提示。
                    FAIL: '验证失败，请点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
                  },
                },
              };
              // 唤醒二次验证（滑动验证码）
              window.nvc.getNC(ncoption);
              this.tagNcFlag = true;
            }
          }
        }
      } else {
        Toast(res.msg);
        this.sliderVer = false;
        window.nvc.reset();
      }
    },
    // 滑块验证弹窗关闭
    closePopup() {
      this.sliderVer = false;
      window.nvc.reset();
    },

    Toast(msg) {
      Toast({
        message: msg,
        duration: 3 * 1000,
        position: 'top',
      });
    },
  },
  created() {
    this.useNvc();
    const { userPhone } = this.$store.state;
    this.userPhone = userPhone || '';
    // this.urlParams = this.$route.query.redirect;
    this.urlParams = window.localStorage.getItem('pagesQuery');
    this.pagesParams = window.localStorage.getItem('pagesParams')
      ? window.localStorage.getItem('pagesParams')
      : null;
  },
  mounted() {
    document.getElementsByClassName('app')[0].setAttribute('style', 'height: 100%');
  },
  beforeDestroy() {
    document.getElementsByClassName('app')[0].removeAttribute('style');
  },
  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
      // alert(`hello${vm.name}`);
      // eslint-disable-next-line no-param-reassign
      vm.fromPath = from.path;
    });
  },
};
</script>
<style lang="scss" scoped>
.fontWeightCom {
  font-weight: 400;
}

.registrationLogin {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #fff;
}

.codeLogin {
  padding-top: 60px;
  font-size: 29px;
}

.codeLoginTitle {
  color: #333;
  font-weight: 500;
  font-size: 44px;
  line-height: 72px;
}

.codeLoginDescribe {
  padding: 18px 0 74px 0;
  color: #787878;
  font-size: 28px;
}

.codeLoginMain {
  width: 605px;
  // height: 84px;
}
.mobile {
  padding: 22px 0;
}
.codeLoginLine {
  width: 605px;
  height: 2px;
  margin-bottom: 56px;
  background-color: #eee;
}

.codeLoginPhone {
  width: 100%;
  height: 100%;
}

.passLoginBtn {
  margin: 21.74px 72.46px 0 0;
  color: #ff6c02;
  font-size: 25px;
  line-height: 36px;
  text-align: right;
}

.registrBottom {
  position: absolute;
  bottom: 48px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .wrapperCenter {
    width: 600px;
    height: 290px;
    background-color: #fff;
    position: relative;
    h2 {
      font-size: 34px;
      line-height: 120px;
      font-weight: normal;
      text-align: center;
    }
    .couponClose {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 34px;
      height: 34px;
    }
    .MyDomSlide {
      width: 600px;
      margin: 30px auto;
    }
  }
}
.sliderCode {
  margin-top: 45px;
}
::v-deep .nc_wrapper {
  margin: 0 auto;
}
::v-deep .nc-container .nc_scale .btn_ok,
::v-deep .nc-container .nc_scale span {
  height: 68px !important;
}
._nc .stage1 .slider {
  height: 52px !important;
  border-radius: 0px !important;
  box-shadow: 0 0 3px #999 !important;
  background-color: #ddd !important;
}
._nc .stage1 .track div {
  border-radius: 0 !important;
  color: #fff !important;
}
.nc .stage1 .bg-green {
  background-color: #78c430 !important;
}
.nc .stage1 .bg-red {
  background-color: #78c430 !important;
}
</style>
<style lang="scss">
.van-popup-agreement{
  .van-icon.van-popup__close-icon{
    width: 16px;
    img{
      width: 100%;
    }
  }
}
</style>
